export default __webpack_public_path__ + "static/media/armep2.bc36b753.jpg";